import { useMemo } from 'react';
import { cloneDeep } from 'lodash';

export const useProcessDesignCards = (data: BlissGalleryECardsThemesData) => {
  const cards: MarketingData = useMemo(() => {
    const joySTDTemplates = new Map(
      data.bliss.stationeryTemplatesContainer.pagedResults.edges
        .filter((edge) => edge.node.category === 'saveTheDate')
        .map((template) => [template.node.themeId, template.node])
    );

    const joyInvitationTemplates = new Map(
      data.bliss.stationeryTemplatesContainer.pagedResults.edges
        .filter((edge) => edge.node.category === 'invitation')
        .map((template) => [template.node.themeId, template.node])
    );

    return data.bliss.themeVariants
      .filter((v) => v.theme)
      .map((card) => {
        const joySTDTemplate = joySTDTemplates.get(card.theme.themeId);
        const joyInvitationTemplate = joyInvitationTemplates.get(card.theme.themeId);

        // Must clone so that we don't mutate the original reference
        const clonedCard: GalleryECard = cloneDeep(card);

        if (joySTDTemplate && joySTDTemplate.approved && joySTDTemplate.enabled) {
          // Adding a query param because `GalleryECard` components appends on a `width` query param
          const thumbnailUrl = joySTDTemplate.thumbnailUrl + '?v=1';
          const maybeSTDVariationTypeMarketingData = clonedCard.theme.marketingData.find((md) => md.variationType === 'savethedate');
          if (maybeSTDVariationTypeMarketingData) {
            maybeSTDVariationTypeMarketingData.imageUrl = thumbnailUrl;
          }
        }

        if (joyInvitationTemplate && joyInvitationTemplate.approved && joyInvitationTemplate.enabled) {
          // Adding a query param because `GalleryECard` components appends on a `width` query param
          const thumbnailUrl = joyInvitationTemplate.thumbnailUrl + '?v=1';
          const maybeInvitationVariationTypeMarketingData = clonedCard.theme.marketingData.find((md) => md.variationType === 'invite');
          if (maybeInvitationVariationTypeMarketingData) {
            maybeInvitationVariationTypeMarketingData.imageUrl = thumbnailUrl;
          }
        }

        return clonedCard;
      });
  }, [data.bliss.stationeryTemplatesContainer.pagedResults.edges, data.bliss.themeVariants]);

  return {
    cards,
  };
};
